import { addAttachmentToIncident, getLocations } from "./AWSAPI";

export const serializeFile = async (file) => {
    try {
        const base64EncodedData = await readFileAsBase64(file);
        const { name: filename, type: content_type } = file;

        const output = {
            filename: filename,
            content_type: content_type,
            base64EncodedData: base64EncodedData,
            error: null
        };
        return output;
    } catch (error) {
        return { error: error.message };
    }
};

const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

export const getFileFromBase64 = (base64Data, fileName, contentType) => {
    try {
        const binaryData = atob(base64Data);
        
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }
        
        const blob = new Blob([uint8Array], { type: contentType });        
        const file = new File([blob], fileName, { type: contentType });
        
        return file;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const submitAttachments = async (incident, files) => {
  const validFiles = Array.isArray(files)
    ? files.filter(f =>
        f &&
        typeof f === "object" &&
        typeof f.filename === "string" &&
        f.filename.trim() !== "" &&
        (
          (typeof f.base64EncodedData === "string" && f.base64EncodedData.trim() !== "") ||
          (typeof f.blobString === "string" && f.blobString.trim() !== "")
        )
      )
    : [];

  if (validFiles.length === 0) {
    return {
      Success: true,
      Skipped: true,
      Message: "No valid files to submit",
    };
  }

  try {
    return await addAttachmentToIncident(incident, validFiles);
  } catch (err) {
    console.log(err);
    return {
      Error: "Attachment request failed.",
      Message: err?.message || String(err),
      Detail: err?.message || String(err),
      RawResponse: err,
    };
  }
};



export const loadLimitedLocations = async (delegate, user) => {
    try {
        const firstBatch = await getLocations(delegate, user, "0", "700");
        if (firstBatch.Error) {
            return { Error: true };
        }
        console.log("First batch of locations retrieved. Starting 2nd batch lookup...");

        const secondBatch = await getLocations(delegate, user, "701", "1500");
        if (secondBatch.Error) {
            return { Error: true };
        }
        console.log("Second batch retrieved!");
        
        if(delegate === "True") {
            const data = [...firstBatch.data.Items, ...secondBatch.data.Items];
            return { data: { Items: data } }
        } else {
            return [...firstBatch, ...secondBatch]
        }

    } catch (err) {
        console.log(err);
        return { Error: true };
    }
};

export const loadPaginatedLocations = async (delegate, user, offset, limit) => {
    try {
        const response = await getLocations(delegate, user, String(offset), String(limit));
        if (response.Error) {
            return { Error: true };
        }
        return response;
    } catch (err) {
        console.log(err);
        return { Error: true };
    }
};